import { loadStripe } from '@stripe/stripe-js';

import * as constants from 'constants/all';

export const stripePromise = loadStripe(constants.STRIPE_API_KEY);
